module.exports = __webpack_public_path__ + "static/media/m_sf_14.b080b042.png";